import { Box } from '@mui/material';

interface ProgressBarProps {
    value: number;
    height?: number;
    barColor?: string;
    trackColor?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
    value,
    height = 10,
    barColor = 'devblue.90',
    trackColor = 'devblue.30',
}) => {
    return (
        <Box
            sx={{
                width: '100%',
                height,
                borderRadius: 1,
                backgroundColor: trackColor,
                overflow: 'hidden',
            }}
        >
            <Box
                sx={{
                    width: `${Math.min(100, value)}%`,
                    bgcolor: barColor,
                    height,
                    borderRadius: 0.75,
                    minWidth: 0,
                }}
            />
        </Box>
    );
};

export default ProgressBar;
